import * as React from 'react'
import { Card, Typography } from '~/components/_atoms'
import { Button } from '~/lib/ui/button'
import YnsIcon from '../../icons/YnsIcon'

export function UkCoachCard({ className }) {
  return (
    <Card
      className={className}
      title="Connect with a Coach"
      color="secondary"
      titleColor="secondary"
      icon={
        <YnsIcon
          name="coach-services-circle"
          className="h-10 w-10 stroke-intoo-green-coachcta"
        />
      }
      actions={
        <a
          href="https://calendly.com/intoo-select-coaching"
          target="_blank"
          rel="noopener noreferrer"
          className="ga-trackable w-full !text-white"
        >
          <Button variant="coachcta" className="w-full">
            Book Now
          </Button>
        </a>
      }
    >
      <Typography>
        Access to expert career advice and support with your career transition.
        Book your coaching session now.
      </Typography>
    </Card>
  )
}
